import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Link from "@mui/material/Link";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import { useGetCertData } from "../hooks/useGetCertData";
import { useGetCertificateFiles } from "../hooks/useGetCertificateFiles";
import { ICertData, IFileItem } from "../declarations";
import { downloadFile } from "../utilities/downloadFile";
import React  from "react";

interface ICertificatesProps {
    guid: string;
}

function formatFileSize(bytes: number): string {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

function CertificateFileList({ cert }: { cert: ICertData }) {
    const { data: files, isLoading } = useGetCertificateFiles(cert.orderID, cert.coOrderItemID);

    if (isLoading) {
        return <Typography variant="body2">Loading files...</Typography>;
    }

    if (!files || files.length === 0) {
        return null;
    }

    return (
        <List dense disablePadding>
            {files
                .filter((file: IFileItem) => !file.isDirectory)
                .map((file: IFileItem) => (
                    <ListItem key={file.name} disableGutters>
                        <ListItemText
                            primary={
                                <Link
                                    component="button"
                                    onClick={() => downloadFile(`SalesOrder/${cert.orderID}`, file.name)}
                                    sx={{ cursor: "pointer" }}
                                >
                                    {file.name}
                                </Link>
                            }
                            secondary={formatFileSize(file.fileSize)}
                        />
                    </ListItem>
                ))}
        </List>
    );
}

export function Certificates(props: ICertificatesProps) {
    const { data, isLoading } = useGetCertData(props.guid);

    if (isLoading) {
        return (
            <Card sx={{ width: "100%" }}>
                <CardHeader title="Certificates" />
                <CardContent>
                    <Typography variant="body1">Loading certificates...</Typography>
                </CardContent>
            </Card>
        );
    }

    if (!data || data.length === 0) {
        return (
            <Card sx={{ width: "100%" }}>
                <CardHeader title="Certificates" />
                <CardContent>
                    <Typography variant="body1">No certificates found for this sail.</Typography>
                </CardContent>
            </Card>
        );
    }

    return (
        <Card sx={{ width: "100%" }}>
            <CardHeader title="Certificates" />
            <CardContent>
                {data.map((cert) => (
                    <CertificateFileList key={cert.coOrderItemID} cert={cert} />
                ))}
            </CardContent>
        </Card>
    );
}
